import $ from "jquery";
import _ from "lodash";

export default function contact() {
   const $html = $("html");
   const $scroller = $("html, body");

   const CONTACT = $('main#content.contact');
   const THANKS = $('main#content.thank-you');

   if(CONTACT.length || THANKS.length) {
      $('.module.-type-section').remove();
   }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/contact.js